const modalConfig = (context, extraProps) => {
  return [
    {
      teacherProfile: context.teacherProfile,
      ...extraProps,
    },
    {
      classes: 'v--modal v--modal_theme_dark',
      clickToClose: false,
      height: 'auto',
      width: 400,
      scrollable: true,
    },
    {
      'before-close': () => context.$parent.fetchProfile(),
    },
  ];
};

export default {
  modalConfig,
};
